import { FC, SVGProps } from 'react'

export const DotsHorizontal: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8889 7.55557C11.8889 8.41114 12.5889 9.11114 13.4444 9.11114C14.3 9.11114 15 8.41114 15 7.55557C15 6.70001 14.3 6 13.4444 6C12.5889 6 11.8889 6.70001 11.8889 7.55557ZM9.55538 7.55557C9.55538 6.70001 8.85537 6 7.99981 6C7.14425 6 6.44424 6.70001 6.44424 7.55557C6.44424 8.41114 7.14425 9.11114 7.99981 9.11114C8.85537 9.11114 9.55538 8.41114 9.55538 7.55557ZM2.55572 6C3.41128 6 4.11129 6.70001 4.11129 7.55557C4.11129 8.41114 3.41128 9.11114 2.55572 9.11114C1.70015 9.11114 1.00015 8.41114 1.00015 7.55557C1.00015 6.70001 1.70015 6 2.55572 6Z"
      fill="currentColor"
      fillOpacity="0.9"
    />
  </svg>
)
